module.exports = __webpack_public_path__ + "static/img/title-bg.7f065f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/title-bg.png
// module id = w3zy
// module chunks = 70